<template>
        <external-mode v-if="mode === 'external'" :customize="customize">
        </external-mode>
        <internal-mode v-else :customize="customize">
        </internal-mode>
</template>

<script>
  import InternalMode from './Internal';
  import ExternalMode from './External';

  export default {
    name: 'KiafWebView',
    components: {
      InternalMode,
      ExternalMode
    },
    props: {
      mode: {
        type: String,
        default: 'internal'
      },
      customize: {
        type: Object,
        default(){
          return {};
        }
      }
    }
  };
</script>
